import React from 'react';
import { personalInfo } from '../data/mock';
import { Card } from './ui/card';
import { MapPin, GraduationCap, Mail, Github, Linkedin, Briefcase } from 'lucide-react';
import { Button } from './ui/button';

const About = () => {
  return (
    <section id="about" className="py-20 px-6">
      <div className="container mx-auto max-w-4xl">
        <div className="space-y-4 mb-12">
          <h2 className="text-sm font-mono text-cyan-500 uppercase tracking-wider">
            Who I am
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold">About Me</h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-6">
            <div className="text-lg text-muted-foreground leading-relaxed space-y-4">
              <p>
                I'm a full-stack developer based in Ratnagiri, India — currently working at{' '}
                <span className="text-foreground font-semibold">Gadre Infotech</span> where I own the entire frontend
                of an enterprise supply chain platform and contribute to .NET Core backend APIs.
              </p>
              <p>
                Before that, I spent two years freelancing — delivering{' '}
                <span className="text-cyan-500 font-semibold">20+ paid projects</span> for international and domestic
                clients across web, mobile, and AI. That experience taught me how to own a project end-to-end,
                communicate asynchronously, and ship without a safety net.
              </p>
              <p>
                I work across the full stack: React and Next.js on the frontend, Python (Flask, FastAPI, Django) and
                Node.js on the backend, Flutter for mobile, and cloud infrastructure on AWS and Azure.
              </p>
              <p>
                I'm <span className="text-cyan-500 font-semibold">actively looking for a remote role</span> with an
                international team — if you're building something ambitious, I'd love to talk.
              </p>
            </div>
          </div>

          <div className="space-y-4">
            <Card className="p-6 space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-cyan-500 mt-0.5" />
                <div>
                  <p className="text-sm text-muted-foreground">Location</p>
                  <p className="font-medium">{personalInfo.location}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Briefcase className="h-5 w-5 text-cyan-500 mt-0.5" />
                <div>
                  <p className="text-sm text-muted-foreground">Availability</p>
                  <p className="font-medium">{personalInfo.availability}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Briefcase className="h-5 w-5 text-cyan-500 mt-0.5" />
                <div>
                  <p className="text-sm text-muted-foreground">Experience</p>
                  <p className="font-medium">1+ yr professional · 2+ yr freelance</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <GraduationCap className="h-5 w-5 text-cyan-500 mt-0.5" />
                <div>
                  <p className="text-sm text-muted-foreground">Education</p>
                  <p className="font-medium">{personalInfo.education}</p>
                </div>
              </div>
            </Card>

            <Card className="p-6 space-y-3">
              <p className="text-sm text-muted-foreground mb-3">Connect</p>
              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={() => window.open(`mailto:${personalInfo.email}`)}
              >
                <Mail className="h-4 w-4 mr-2" />
                Email
              </Button>
              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={() => window.open(personalInfo.github, '_blank')}
              >
                <Github className="h-4 w-4 mr-2" />
                GitHub
              </Button>
              <Button
                variant="outline"
                className="w-full justify-start"
                onClick={() => window.open(personalInfo.linkedin, '_blank')}
              >
                <Linkedin className="h-4 w-4 mr-2" />
                LinkedIn
              </Button>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
